// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mhah","field":"styles_field___A_I_","fieldCol":"styles_fieldCol__2CG4V","diffCol":"styles_diffCol__1pTPH","diff":"styles_diff__b1n1z"};